import { handleRequest } from "../utilities/requestHandler";

export const getMachinesWithModels = (req_body) =>
    handleRequest("post","/machines/with-models",req_body);

export const getSiteLines = ({ site_number, site_id, cus_id } = {}) => {
    const params = new URLSearchParams();
    if (site_number) params.set("site_number", site_number);
    if (site_id) params.set("site_id", site_id);
    if (cus_id) params.set("cus_id", cus_id);
    const query = params.toString();
    return handleRequest("get", query ? `/machines/site-lines?${query}` : "/machines/site-lines");
};

export const getMachinesByIds = (req_body) =>
    handleRequest("post", "/machines/by-ids", req_body);

export const getMachineByNumberOrId = (req_body) =>
    handleRequest("post", "/machines/by-number-or-id", req_body);
